import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'foundations-components/transitional/components/List';
import ModalWrapper from '../ModalWrapper';
import GoToProcessorPickerButtonWrapper from '../../GoToProcessorPickerButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import { track } from '../../../tracking/track';
import { events } from '../../../tracking/events';
import { getSubscriptionsURL } from 'growth-payments-core/urls/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CollectPaymentsWithSubscriptionsModal = ({
  onClose,
  page,
  location,
  ButtonPrimary = GoToProcessorPickerButtonWrapper
}) => {
  const Body = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(List, {
      styled: true,
      wrapChildren: true,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.collectPaymentsWithSubscriptions.bullet1"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.collectPaymentsWithSubscriptions.bullet2"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.collectPaymentsWithSubscriptions.bullet3"
      })]
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.collectPaymentsWithSubscriptions.p2"
    })]
  });
  const Footer = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ButtonPrimary, {
      sourceApp: page,
      location: location,
      use: "primary"
    }), /*#__PURE__*/_jsx(Button, {
      "data-test-id": "create-subscription-button",
      use: "secondary",
      rel: "noopener" // override the rel attribute to remove the "noreferrer" tag, slack ref - https://hubspot.slack.com/archives/CEZNHE030/p1696003611704799
      ,
      external: true,
      href: getSubscriptionsURL(),
      onClick: () => track(events.paymentsInterstitialModalInteraction, {
        action: 'click',
        screen: page,
        value: 'createSubscription'
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.ctas.createSubscription"
      })
    })]
  });
  return /*#__PURE__*/_jsx(ModalWrapper, {
    onClose: onClose,
    modalName: "collectPaymentsWithSubscriptions",
    Body: Body,
    Footer: Footer,
    illustrationName: "payments-subscriptions",
    paddingBlockStart: "500",
    paddingBlockEnd: "1000",
    paddingInlineEnd: "1000"
  });
};
export default CollectPaymentsWithSubscriptionsModal;